import type { IconName } from './icon';
// Imported (not from public/) so Vite content-hashes them → cache busts on change.
import metroImg from '@/assets/icons/metro.webp';
import busImg from '@/assets/icons/bus.webp';
import rideImg from '@/assets/icons/ride.webp';
import entryImg from '@/assets/icons/entry.webp';

export type Category = 'metro' | 'bus' | 'ride' | 'pass';

interface CategoryMeta {
  label: string;
  icon: IconName;
  cls: string;
  /** Category illustration (public/icons/*.png) — used by LeadIcon when no icon override. */
  img: string;
}

export const CATEGORY: Record<Category, CategoryMeta> = {
  metro: { label: 'Metro', icon: 'metro', cls: 'cat-metro', img: metroImg },
  bus: { label: 'Bus', icon: 'bus', cls: 'cat-bus', img: busImg },
  ride: { label: 'Ride', icon: 'cab', cls: 'cat-ride', img: rideImg },
  pass: { label: 'Pass', icon: 'sparkle', cls: 'cat-pass', img: entryImg },
};
